// Edit these two labels whenever the marketing wording changes.
export const marketingConsentText = {
  newsletter: `Add me to the ${import.meta.env.VITE_SITE_BRAND === 'excelafterdark' ? 'Excel After Dark' : 'How Do You Excel'} newsletter.`,
  productAnnouncements: 'Email me when you release your next cool Excel product.',
} as const;

// Increment this date whenever the meaning of either consent changes materially.
export const marketingConsentVersion = '2026-08-09';
